export class documentRequestTemplateUrl  {
    documentRequestTemplate = "sse/v1/document-request-template[?FilterText][&PageNumber][&PageSize][&SortColumn][&SortOrder]";
 }